import React, { useState, useEffect, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { apiBaseUrl, generateQr } from '../../util/api';
import axios from 'axios';
import css from './PromotionQR.module.css';
const PromotionQR = () => {
  const [token, setToken] = useState(null);
  const [expiresAtMs, setExpiresAtMs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);
  const timerRef = useRef(null);

  const fetchQR = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await generateQr({}, { withCredentials: true });
      setToken(response.token);
      setExpiresAtMs(response.expiresAtMs);
    } catch (err) {
      console.error('Error fetching QR:', err);
      setError('Could not generate code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (expiresAtMs) {
      const updateTimer = () => {
        const now = Date.now();
        const diff = Math.max(0, Math.floor((expiresAtMs - now) / 1000));
        setTimeLeft(diff);

        if (diff <= 0) {
          fetchQR();
        }
      };

      updateTimer();
      timerRef.current = setInterval(updateTimer, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [expiresAtMs]);

  const handleGenerate = () => {
    fetchQR();
  };

  return (
    <div className={css.root}>
      {!token && !loading && (
        <button className={css.button} onClick={handleGenerate}>
          Generate Promotion Code
        </button>
      )}

      {loading && <div className={css.loading}>Generating...</div>}

      {error && <div className={css.error}>{error}</div>}

      {token && !loading && (
        <div className={css.qrContainer}>
          <QRCodeSVG value={token} size={256} />
          <div className={css.timer}>
            Code refreshes in: <span>{timeLeft}s</span>
          </div>
          <button className={css.refreshButton} onClick={fetchQR}>
            Refresh now
          </button>
        </div>
      )}
    </div>
  );
};

export default PromotionQR;
